<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - MAC-Pool: {{macReservationDto.pool.name}} - Reservation Response</span>
                    </v-card-title>

                    <v-divider></v-divider>


                    <v-container class="scroll-y" grid-list-xs fluid style="margin-top: -20px; min-height: 475px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12>
                                <v-subheader class="body-2">Reservation for MAC-Pool congatec (ID: {{
                                    macReservationDto.pool.poolId }}, OUI: {{
                                    macReservationDto.pool.oui}}) was successful.
                                </v-subheader>
                            </v-flex>

                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Start MAC</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macReservationDto.pool.startMac}}</b></v-subheader>
                            </v-flex>


                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>End MAC</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macReservationDto.pool.endMac}}</b></v-subheader>
                            </v-flex>

                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Next MAC</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macReservationDto.pool.nextMac}}</b></v-subheader>
                            </v-flex>


                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Amount of reserved MAC-Addresses</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macReservationDto.reservedMacs}}</b></v-subheader>
                            </v-flex>


                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>First reserved MAC</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macReservationDto.firstReservedMac}}</b></v-subheader>
                            </v-flex>

                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Last reserved MAC</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macReservationDto.lastReservedMac}}</b></v-subheader>
                            </v-flex>

                            <v-flex xs12 sm4 md6 class="modal-flex-height">
                                <v-subheader>Export reserved MACs</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md5 class="modal-flex-height compact-form">
                                <v-textarea
                                        v-model="rangeOfReservedMacs"
                                        id="range_of_reserved_macs"
                                        color="grey darken-2"
                                        :readonly="true"
                                ></v-textarea>
                                <v-card-actions>
                                    <v-btn id="copy_reserved_macs_button" class="text-none" small @click="copyMacAddressRangeToClipBoard">
                                        <v-icon>fa-copy</v-icon>
                                    </v-btn>
                                    <v-btn id="download_reserved_macs_button" class="text-none" small @click="downloadMacAddresses">
                                        <v-icon>fa-download</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="finish_reserve_mac_button" class="text-none" small @click="close">Ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>
    import {EventBus} from "../../../eventbus";
    import macaddressservice from "../../../services/macaddressservice";

    export default {
        name: 'MacPoolReservationResponseModal',

        props: {
            value: Boolean,

            macReservationDto: {
                pool: {
                    poolId: Number,
                    oui: Number,
                    name: String,
                    startMac: String,
                    endMac: String,
                    nextMac: String,
                    available: Number,
                    availableInPercent: Number,
                    capacity: Number,
                    isActive: Boolean,
                    macsPerReq: Number,
                    macsPerUserDay: Number
                },
                requestedMacs: Number,
                firstReservedMac: String,
                lastReservedMac: String,
                remainingMacPerUserDay: String,
            },

            rangeOfReservedMacs: String
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            close() {
                EventBus.$emit('macReservationClosed');
                EventBus.$emit('reservationResponseDialogClosed');
                this.onShow = false;
                this.$emit('close');
            },

            downloadMacAddresses() {
                macaddressservice.downloadReservedMacRangeAsTextFile(this.macReservationDto.firstReservedMac,
                    this.macReservationDto.lastReservedMac, this.macReservationDto.pool.oui, this.macReservationDto.pool.name);
            },

            copyMacAddressRangeToClipBoard() {
                let rangeOfReservedMacAddresses = document.querySelector('#range_of_reserved_macs');
                rangeOfReservedMacAddresses.setAttribute('type', 'text');
                rangeOfReservedMacAddresses.select();

                try {
                    document.execCommand('copy');
                } catch (err) {
                    console.log("Copy to clipboard was not successful.")
                }

                // unselect the range 
                rangeOfReservedMacAddresses.setAttribute('type', 'hidden');
                window.getSelection().removeAllRanges()
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/macpools/modals/MacPoolReservationResponseModal.vue